import { Stack } from '@mui/material'
import { KeyboardArrowRight } from '@mui/icons-material'
import { ModalFooterButton } from '@/components/Modal'

import { useController } from '../../../hooks/useController'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useTexts } from '../../../hooks/useTexts'
import { Footer } from './Footer'

export function ConfigureTerritoriesFooter() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const { close, status, invalid } = useController()

  return (
    <Footer>
      {/* the empty div will let the stack to align to the right for the justify-content of the Footer */}
      <div />
      <Stack gap={1} direction="row">
        <ModalFooterButton onClick={close} testid="modal-secondary-button">
          {texts.cancelButton}
        </ModalFooterButton>
        <ModalFooterButton
          disabled={invalid || status !== 'ready'}
          onClick={handlers.onGoToConfigureFormat}
          variant="contained"
          loading={handlers.isLoading}
          testid="modal-primary-button"
        >
          {texts.nextStepButton}
          <KeyboardArrowRight />
        </ModalFooterButton>
      </Stack>
    </Footer>
  )
}
